<div class="idle-page-container">
    <gux-page-loading-spinner></gux-page-loading-spinner>
    <gux-loading-message>
        <div slot="primary-message">The content is loading...</div>
        <div slot="additional-guidance">Thank you for waiting.</div>
    </gux-loading-message>
</div>